import React from 'react';
import { AlertCircle, Phone } from 'lucide-react';
import { useTheme } from '../../hooks/useTheme';

const CrisisSupport = () => {
  const { theme } = useTheme();

  return (
    <div className={`p-6 rounded-xl bg-red-50 ${theme === 'dark' ? 'bg-red-900/20' : ''}`}>
      <div className="flex items-start space-x-4">
        <AlertCircle className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" />
        <div className="flex-1">
          <h3 className={`font-semibold mb-1 ${theme === 'dark' ? 'text-red-200' : 'text-red-900'}`}>
            Need immediate support?
          </h3>
          <p className={`text-sm mb-3 ${theme === 'dark' ? 'text-red-300' : 'text-red-700'}`}>
            If you're in crisis or need someone to talk to right away
          </p>
          <div className="flex flex-wrap gap-3">
            <a 
              href="tel:988"
              className="inline-flex items-center space-x-2 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700"
            >
              <Phone className="w-4 h-4" />
              <span>Call 988</span>
            </a>
            <a 
              href="sms:741741"
              className="inline-flex items-center space-x-2 bg-white text-red-600 border border-red-600 px-4 py-2 rounded-lg hover:bg-red-50"
            >
              <span>Text HOME to 741741</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrisisSupport;